export default __webpack_public_path__ + "3c7c30ece8023c308bd62c2b5d163aee.svg";